import { ethers } from "ethers";
import React, { Component } from "react";
import getContract, {getAutoRunContract} from "../../services/contract";
import { Link } from 'react-router-dom';
import transactionTypes from '../../helpers/transactionType';
import withWrapper from '../../helpers/withWrapper';
import getWallet from '../../services/wallet';
import { ToastContainer, toast } from 'react-toastify';
import { TransactionService } from '../../services/transactionService';

class AutoRun extends Component {
  state = {
    ids: new Array(31).fill(0),
    currentParrentAutoRunId: 0
  };
  constructor(props) {
    super(props);
    this.state.userId = props.router.params.id;
  }

  notify = (message) => toast(message);

  handleIdClick = async (ids) => {
    await this.fetchData(ids.id, ids.autoRunId);
    this.props.router.navigate('/autorun/' + ids.id);
  }


  async componentDidMount() {
    await this.fetchData(this.state.userId);
  }

  fetchData = async (id, autoRunId) => {
    const promise = this.setData(id, autoRunId);

    await toast.promise(
      promise,
        {
          pending: 'Fetching data wait...',
          success: 'Ready to view!',
          error: 'Error fetching data'
        }
    )
  }

  setData = async (userId, autoRunId) => {
    // console.log("userId: ", userId);
    // console.log("autoRunId: ", autoRunId);
    
    const xGoldcontract = await getContract();
    const contract = await getAutoRunContract();
    const userAddress = await xGoldcontract.getAddressById(userId);

    let userNodeInfoResponse;
    if(autoRunId) {
      userNodeInfoResponse = await contract.getAutoRunIdMatrixInfo(autoRunId);
    } else {
        userNodeInfoResponse = await contract.getUserAutoRunMatrixInfo(userId);
        autoRunId = await contract.userLatestAutoRunIdentfier(userId);
    }
    console.log("autoRunId: ", ethers.BigNumber.from(autoRunId).toNumber());
    
    const payersCount = ethers.BigNumber.from(await contract.autoRunIdPayersCount(autoRunId)).toNumber()
    console.log("payersCount: ", payersCount);

    // const response = await contract.getAutoRunMatrixRow(2);
    // console.log("response: ", response);
    
    const currentParrent = ethers.BigNumber.from(userNodeInfoResponse["currentParent"]).toNumber();
    const currentParrentAutoRunId = ethers.BigNumber.from(userNodeInfoResponse["currentParentAutoRunId"]).toNumber();
    
    console.log("currentParrent: ", currentParrent);
    console.log("currentParrentAutoRunId: ", currentParrentAutoRunId);
    
    // const childsArray = userAutoRunMatrixInfoResponse["childs"];
    // const row = await contract.getAutoRunMatrixRow(0);
    
    const idsResponse = await contract.getAutoRunMatrixForSpecificNode(autoRunId, 4);
    // console.log("idsResponse: ", idsResponse);
    
    const ids = [];
    idsResponse.forEach((response, index) => {
      const id = ethers.BigNumber.from(response["userId"]).toNumber();
      const autoRunId = ethers.BigNumber.from(response["autoRunId"]).toNumber();
      ids[index] = {id, autoRunId};
    });

    this.setState({ 
      ids, userAddress, userId, currentParrent, currentParrentAutoRunId,

     });
  }

  handleAutorunBuy = async () => {
    const wallet = await getWallet();
    if (wallet.isReadOnly) {
      this.notify("Please connect your wallet");
      return;
    }
    const userBrowserAddresses = await wallet.provider.listAccounts();
    if (this.state.userAddress !== userBrowserAddresses[0]) {
      this.notify("You can't Buy for other person's, if its yours then connect your wallet with this ID");
      return;
    }
    try {
      var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
      const autorunPromise = transactionService.joinAutorun();
      await toast.promise(
        autorunPromise,
        {
          pending: 'Transaction in process please wait...',
          success: 'Join Successfully! 👌',
          error: 'Joining failed '
        }
      )
      await this.fetchData(this.state.userId);
    } catch (error) {
      alert(error.message);
    }
  }

  copyToClipboard = (value) => {

  }

  getClass = (id) => {
    return "bg-orange";
    const idIndex = this.state.ids.indexOf(id);
    console.log(idIndex);

    // const transactions = this.state.childrenTransactionTypes.filter(t => t.userId == id && t.index == idIndex);
    // if(transactions.length > 1) {

    // }
    const txType = this.state.childrenTransactionTypes.find(t => t.userId == id);
    return (txType) ? txType.typeProperties.class : "bg-orange";
  }

  render() {
    return (
      <div style={{ backgroundColor: "#000000", backgroundImage: "url('/logo/b23.JPG')"}} className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
        <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
          <div className="flex flex-col space-y-10 sm:space-y-7.5 z-0">
            <div className="flex z-10 !mt-0 justify-center items-center">
              <div className="flex flex-col w-full flex-wrap sm:px-5">
                <div className="w-full flex justify-center flex-wrap">
                  <div className="flex items-center">
                    <span className="text-two-half text-white font-medium mr-2 sm:text-2xl whitespace-nowrap">
                      AutoRun Matrix
                    </span>
                    <i className="fas fa-running fa-3x text-white mr-2"></i>
                  </div>
                </div>
                <div className="w-full flex justify-center flex-wrap mt-2">
                  <div className="flex items-center">
                   
                  <button style={{background: 'white'}} className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 py-5 !px-10 sm:py-5 sm:mt-7.5" 
                    id="nextButton" onClick={this.handleAutorunBuy}>Join - 625 USDT </button>
                  </div>
                </div>
              </div>
            </div>
            <a 
              className="flex w-full items-center justify-center sm:px-5 z-10"
            >
              <button style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem"}}
              onClick={() => this.handleIdClick({id: this.state.currentParrent, autoRunId: this.state.currentParrentAutoRunId})} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray !p-5 w-8/12 xl:w-full sm:!p-4 rounded font-normal">
                <span className="text-white text-base !leading-30px sm:text-sm">
                  Upline
                </span>
                <span className="rounded bg-white-100 px-2.5 text-white text-base ml-2.5 !leading-30px sm:text-sm">
                  ID {this.state.currentParrent}
                </span>
              </button>
            </a>
            <div className="">
              <div className="flex flex-col sm:px-5 space-y-10 z-10 mb-5">
                <div className="flex space-x-10 xl:space-x-0 z-10">
                  <div style={{ backgroundColor: "black", borderRadius: "0 3rem 3rem 3rem"}}
                    className="flex w-full min-h-340px sm:min-h-290px col-span-4 rounded relative bg-gray-900 hover:bg-gray-800 ">
                    <div className="flex w-full flex-col z-10 p-7.5 sm:p-5">
                      <div className="flex w-full justify-between mb-7.5 z-10">
                        <div className="flex flex-1 items-start justify-start ">
                          {/* <div className="flex items-center space-x-2.5">
                            <span className="text-white-300 text-two-half font-normal sm:text-xl">
                              {this.state.reinvestNo}
                            </span>
                          </div> */}
                        </div>
                        <div className="flex-1 flex flex-col items-center">
                          <span className="text-white text-two-half font-medium mb-2.5 sm:text-xl">
                            ID {this.state.userId}
                          </span>
                        </div>
                        <div className="flex items-start justify-end flex-1 text-white-300 text-two-half font-normal text-right  sm:text-xl"></div>
                      </div>
                      <div className="flex flex-col w-full h-full z-10">
                        <div className="flex justify-center mb-5 sm:mb-10">
                          <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                            <div className="flex flex-col justify-around items-center w-full">
                            <a onClick={() => this.handleIdClick(this.state.ids[1])}>
                                <div className="relative">
                                  { (!this.state.ids[1].id) ? 
                                    <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75">
                                      <img
                                        src="/logo/favicon.ico"
                                        className="w-6 h-6 sm:h-4 sm:w-4 false"
                                      />
                                    </div> : 
                                    <div className={"flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 "
                                        + this.getClass(this.state.ids[1].id)}>
                                      <span className="text-black text-base sm:text-sm">{this.state.ids[1].id}</span>
                                    </div>
                                  }
                                </div>
                              </a>
                              <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                <div className="flex flex-col justify-around items-center w-full">
                                <a onClick={() => this.handleIdClick(this.state.ids[3])}>
                                    <div className="relative">
                                      { (!this.state.ids[3].id) ?
                                        <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                        <img
                                          src="/logo/favicon.ico"
                                          className="w-6 h-6 sm:h-4 sm:w-4 false"
                                        />
                                        </div> : 
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                          + this.getClass(this.state.ids[3].id)}>
                                          <span className="text-black text-base sm:text-sm">{this.state.ids[3].id}</span>
                                        </div>
                                      }
                                      
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.ids[7])}>
                                        <div className="relative">
                                          { (!this.state.ids[7].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> : 
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                            + this.getClass(this.state.ids[7].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[7].id}</span>
                                          </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[15])}>
                                            <div className="relative">
                                              { (!this.state.ids[15].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> :
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[15].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[15].id}</span>
                                              </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[16])}>
                                            <div className="relative">
                                            { (!this.state.ids[16].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> :
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[16].id)} >
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[16].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[8])}>
                                        <div className="relative">
                                        { (!this.state.ids[8].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> :
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                              + this.getClass(this.state.ids[8].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[8].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[17])}>
                                            <div className="relative">
                                            { (!this.state.ids[17].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                  + this.getClass(this.state.ids[17].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[17].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[18])}>
                                            <div className="relative">
                                            { (!this.state.ids[18].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[18].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[18].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col justify-around items-center w-full">
                                <a onClick={() => this.handleIdClick(this.state.ids[4])}>
                                    <div className="relative">
                                    { (!this.state.ids[4].id) ?
                                      <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                        <img
                                          src="/logo/favicon.ico"
                                          className="w-6 h-6 sm:h-4 sm:w-4 false"
                                        />
                                        </div> : 
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                          + this.getClass(this.state.ids[4].id)}>
                                          <span className="text-black text-base sm:text-sm">{this.state.ids[4].id}</span>
                                        </div>
                                      }
                                      </div> 
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[9])}>
                                        <div className="relative">
                                        { (!this.state.ids[9].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> :
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                              + this.getClass(this.state.ids[9].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[9].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[19])}>
                                            <div className="relative">
                                            { (!this.state.ids[19].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[19].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[19].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[20])}>
                                            <div className="relative">
                                            { (!this.state.ids[20].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[20].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[20].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[10])}>
                                        <div className="relative">
                                        { (!this.state.ids[10].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> : 
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                          + this.getClass(this.state.ids[10].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[10].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[21])}>
                                            <div className="relative">
                                            { (!this.state.ids[21].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                              + this.getClass(this.state.ids[21].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[21].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[22])}>
                                            <div className="relative">
                                            { (!this.state.ids[22].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[22].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[22].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col justify-around items-center w-full">
                            <a onClick={() => this.handleIdClick(this.state.ids[2])}>
                                <div className="relative">
                                { (!this.state.ids[2].id) ? 
                                    <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75">
                                    <img
                                      src="/logo/favicon.ico"
                                      className="w-6 h-6 sm:h-4 sm:w-4 false"
                                    />
                                    </div> : 
                                    <div className={"flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 " 
                                      + this.getClass(this.state.ids[2].id)}>
                                      <span className="text-black text-base sm:text-sm">{this.state.ids[2].id}</span>
                                    </div>
                                }
                                  
                                </div>
                              </a>
                              <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                <div className="flex flex-col justify-around items-center w-full">
                                <a onClick={() => this.handleIdClick(this.state.ids[5])}>
                                    <div className="relative">
                                    { (!this.state.ids[5].id) ?
                                      <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                        <img
                                          src="/logo/favicon.ico"
                                          className="w-6 h-6 sm:h-4 sm:w-4 false"
                                        />
                                      </div> : 
                                      <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                        + this.getClass(this.state.ids[5].id)}>
                                        <span className="text-black text-base sm:text-sm">{this.state.ids[5].id}</span>
                                      </div>
                                      } 
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[11])}>
                                        <div className="relative">
                                        { (!this.state.ids[11].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> : 
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                            + this.getClass(this.state.ids[11].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[11].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[23])}>
                                            <div className="relative">
                                            { (!this.state.ids[23].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> :
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[23].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[23].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[24])}>
                                            <div className="relative">
                                            { (!this.state.ids[24].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[24].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[24].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[12])}>
                                        <div className="relative">
                                        { (!this.state.ids[12].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> :
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                            + this.getClass(this.state.ids[12].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[12].id}</span>  
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[25])}>
                                            <div className="relative">
                                            { (!this.state.ids[25].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> :
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[25].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[25].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[26])}>
                                            <div className="relative">
                                            { (!this.state.ids[26].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                + this.getClass(this.state.ids[26].id)}>
                                                <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.ids[26].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col justify-around items-center w-full">
                                <a onClick={() => this.handleIdClick(this.state.ids[6])}>
                                    <div className="relative">
                                    { (!this.state.ids[6].id) ?
                                      <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                        <img
                                          src="/logo/favicon.ico"
                                          className="w-6 h-6 sm:h-4 sm:w-4 false"
                                        />
                                      </div> : 
                                      <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                        + this.getClass(this.state.ids[6].id)}>
                                        <span className="text-black text-base sm:text-sm">{this.state.ids[6].id}</span>
                                      </div>
                                      }
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                    <a onClick={() => this.handleIdClick(this.state.ids[13])}>
                                        <div className="relative">
                                        { (!this.state.ids[13].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> : 
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                            + this.getClass(this.state.ids[13].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[13].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[27])}>
                                            <div className="relative">
                                            { (!this.state.ids[27].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[27].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[27].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a href="#"></a>
                                          <a onClick={() => this.handleIdClick(this.state.ids[28])}>
                                            <div className="relative">
                                            { (!this.state.ids[28].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[28].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[28].id}</span>  
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                      </div>
                                      <a href="#"></a>
                                    </div>
                                    <a href="#"></a>
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a href="#"></a>
                                      <a onClick={() => this.handleIdClick(this.state.ids[14])}>
                                        <div className="relative">
                                        { (!this.state.ids[14].id) ? 
                                          <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                            <img
                                              src="/logo/favicon.ico"
                                              className="w-6 h-6 sm:h-4 sm:w-4 false"
                                            />
                                          </div> :
                                          <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 " 
                                            + this.getClass(this.state.ids[14].id)}>
                                            <span className="text-black text-base sm:text-sm">{this.state.ids[14].id}</span>
                                          </div>
                                        }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                        <a onClick={() => this.handleIdClick(this.state.ids[29])}>
                                            <div className="relative">
                                            { (!this.state.ids[29].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> : 
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[29].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[29].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a href="#"></a>
                                          <a onClick={() => this.handleIdClick(this.state.ids[30])}>
                                            <div className="relative">
                                            { (!this.state.ids[30].id) ? 
                                              <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                <img
                                                  src="/logo/favicon.ico"
                                                  className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                />
                                              </div> :
                                              <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false " 
                                                + this.getClass(this.state.ids[30].id)}>
                                                <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.ids[30].id}</span>
                                              </div>
                                            }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex absolute rounded -bottom-5 top-5 right-5 left-2.5 bg-opacity-50"></div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <footer style={{ backgroundColor: "rgba(0, 0, 0, 0)"}} className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10">
            <div className="hidden lg:block mb-7.5">
              <div className="flex space-x-5 w-full">
                <a
                  className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                  target="_blank"
                  href="https://t.me/tbi_2024"
                >
                  <svg
                    className="w-3 h-3 sm:w-4 sm:h-4"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            <div id="google_translate_element"></div>
            <span className="text-white-500 text-xs font-normal lg:mb-2.5">
              © 20242 All Rights Reserved
            </span>
          </footer>
        </div>
      </div>
    );
  }
}

export default withWrapper(AutoRun);
